module.exports = "<app-aside-nav></app-aside-nav>\n<router-outlet></router-outlet>\n"